export default class Job {
  constructor() {
    window.addEventListener('DOMContentLoaded', () => {
      for (let i = 0; i < 20; i++) {
        // console.log(i + 1)
        setEvent(
          document.querySelector(`.js-job-trigger-${i+1}`),
          document.querySelector(`.js-job-target-${i+1}`)
        )
      }
    })
    function setEvent(trigger, target) {
      if(!trigger || !target) return
      trigger.addEventListener('mouseenter', () => {
        target.classList.add('is-hover')
      })
      trigger.addEventListener('mouseleave', () => {
        target.classList.remove('is-hover')
      })
    }
  }
}
